import { AxiosPromise } from "axios";
import { EnvironmentFactory } from "src/factory/EnvironmentFactory/environment.factory";
import { Util } from "src/utils/Util";
import { IQuotationData } from "../interfaces/IQuotationData";
import { IQuotationRequest } from "../interfaces/IQuotationRequest";
import { IQuotationRenewalData } from "../interfaces/IQuotationRenewalData";
import { IQuotationRenewalRequest } from "../interfaces/IQuotationRenewalRequest";

/**
 *
 */
export namespace PlanManagementService {

  
  /**
   * 
   * @param data 
   * @returns 
   */
  export const quotationService = (data: IQuotationRequest): AxiosPromise<IQuotationData> => {
    return EnvironmentFactory.Http.SecureHttp().post(Util.API_PATH.QUOTATION, data);
  };

  
  /**
   * 
   * @param data 
   * @returns 
   */
  export const quotationRenewalService = (request: IQuotationRenewalRequest): AxiosPromise<IQuotationRenewalData> => {
    return EnvironmentFactory.Http.SecureHttp().post(Util.API_PATH.QUOTATION_RENEWAL, request);
  };
}